// extracted by mini-css-extract-plugin
export default {"link":"CustomeLink_link__zYQuo"};